$("document").ready(function() {
    $(".banner-slider").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true
    });
    $(".announcement-bar-section").removeClass("hidden-announsment");
    $(".menu-brows li.p1").hasClass("active_link");
    $(".menu-brows li.p1").on("click", function() {
        $(this).addClass("active_link");
    });
    if ($(window).width() > 1024) {
        $("nav.header_browse_cat").hover(function() {
            $(this).find(".toggle_button").toggleClass("activ_val");
            $(this).find(".list-menu-browse").toggleClass("open");
        });
    }
    $(".footer-block__heading").click(function() {
        $(this).toggleClass("activ_footer");
        $(this).parent(".footer-block").find(".footer-block__details-content").toggleClass("active");
    });
    $(document).on("click", ".qtyboxm .quantity__button  ", function() {
        var qty = parseInt($(this).parents(".product-form__quantit").find(".quantity__input").val());
        qty = isNaN(qty) ? 0 : qty;
        $(this).parents(".product-form__quantit").find(".quantity__input").val(qty);
        $(this).parents(".quick-add").find("product-form #quantity").val(qty);
    });
    $(".categories-list__item").slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        responsive: [ {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        }, {
            breakpoint: 991,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 576,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        } ]
    });
    $(".customers-list__item").slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        responsive: [ {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true
            }
        }, {
            breakpoint: 991,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        } ]
    });
    $(".home_product .home_feature_slider").slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        adaptiveHeight: true,
        responsive: [ {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true
            }
        }, {
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        } ]
    });
    $(".announcement-bar-mobile .page-width").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5e3
    });
    $(".search-icon-header").click(function() {
        $(".mobile-search-button .field").toggle();
    });
    $(".banner-mobile-slider").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true
    });
    setTimeout(function() {
        $(".announcent-content").css("visibility", "visible");
    }, 500);
});

$(window).on("load", function() {
    setTimeout(function() {
        var parth_url = location.pathname;
        $(".menu-brows li.p1").each(function() {
            var loc_url = $(this).find("a").attr("href");
            if (loc_url == parth_url) {
                $(this).addClass("active_link");
            }
        });
    }, 1e3);
});

$(document).ready(function() {
    $(".recipe_blog .blog__posts").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplaySpeed: 2e3,
        arrows: true
    });
});

$(".logo_slider").slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4e3,
    arrows: true,
    responsive: [ {
        breakpoint: 1200,
        settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true
        }
    }, {
        breakpoint: 992,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1
        }
    }, {
        breakpoint: 749,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1
        }
    }, {
        breakpoint: 481,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    } ]
});

$(document).ready(function() {
    $("ul.tabs li").click(function() {
        $(this).addClass("active");
        $(this).siblings("ul.tabs li").removeClass("active");
        var activeTab = $(this).attr("rel");
        $("#" + activeTab).addClass("active_content");
        $("#" + activeTab).siblings(".tab_content").removeClass("active_content");
        $(".arrow[rel^='" + activeTab + "']").addClass("d_active");
        $(".arrow[rel^='" + activeTab + "']").siblings(".arrow").removeClass("d_active");
    });
    $(".arrow").on("click", function() {
        if ($(this).hasClass("d_active")) $(this).next().slideUp("slow"), $(this).removeClass("d_active"), 
        $(this).next().removeClass("active_content"); else {
            $(this).toggleClass("d_active"), $(this).siblings(".arrow").removeClass("d_active");
            var e = $(this).attr("rel");
            $(".tab_content").slideUp("slow");
            $(this).next().slideDown("slow");
        }
    });
});

$(document).ready(function() {
    if ($(window).width() < 481) {
        $(".related_product .slider_related").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            infinite: true,
            arrows: false
        });
    }
});

$(document).ready(function() {
    if (window.matchMedia("(max-width: 1024px)").matches) {
        $(".header_browse_cat .toggle_button").on("click", function() {
            $(".list-menu-browse").toggleClass("open");
            $(this).toggleClass("activ_val");
            $("body").toggleClass("Header_sub");
        });
    }
});

$(document).ready(function() {
    setTimeout(function() {
        $(".product-grid li").each(function() {
            var textContent = $(this).find(".card__information a.full-unstyled-link").attr("href");
            var regex = /variant=(\d+)/;
            var variantValue = regex.exec(textContent);
            if (variantValue && variantValue.length >= 2) {
                variantValue = variantValue[1];
                $(this).find(".variant-data-card-product select").val(variantValue);
                $(this).find(".variant-data-card-product select").change();
            }
        });
    }, 1e3);
    $(document).on("change", "ul.product-grid .variant-data-card-product select", function() {
        if ($(this).find(":selected").attr("variant-discount-card") == "false") {
            $(this).parents(".grid__item").find(".badge--sale").addClass("hidden");
        } else {
            $(this).parents(".grid__item").find(".badge--sale").removeClass("hidden");
            $(this).parents(".grid__item").find(".badge--sale span").html($(this).find(":selected").attr("variant-discount-card"));
        }
        $(this).parents(".grid__item").find(".price-item.price-item--regular , .price-item.price-item--sale.price-item--last").html($(this).find(":selected").attr("variant-price-card"));
        if ($(this).find(":selected").attr("variant-compare-price-card") == "false") {
            $(this).parents(".grid__item").find("s.price-item.price-item--regular").addClass("hidden");
        } else {
            $(this).parents(".grid__item").find("s.price-item.price-item--regular").removeClass("hidden");
            $(this).parents(".grid__item").find("s.price-item.price-item--regular").html($(this).find(":selected").attr("variant-compare-price-card"));
        }
        $(this).parents(".grid__item").find("product-form .formId").val($(this).find(":selected").attr("variant-id-card"));
        if ($(this).find(":selected").attr("variant-stock-card") == "true") {
            $(this).parents(".grid__item").find("button.quick-add__submit span").first().text("Add to Cart");
            $(this).parents(".grid__item").find("button.quick-add__submit").removeAttr("disabled", "disabled");
            $(this).parents(".grid__item").find(".card__information p.p2").addClass("stock");
            $(this).parents(".grid__item").find(".card__information p.p2").removeClass("out");
            $(this).parents(".grid__item").find(".card__information p.p2").text("In Stock!");
        } else {
            $(this).parents(".grid__item").find("button.quick-add__submit span").first().text("Sold Out");
            $(this).parents(".grid__item").find("button.quick-add__submit").attr("disabled", "disabled");
            $(this).parents(".grid__item").find(".card__information p.p2").removeClass("stock");
            $(this).parents(".grid__item").find(".card__information p.p2").addClass("out");
            $(this).parents(".grid__item").find(".card__information p.p2").text("Out of Stock");
        }
        if ($(this).find(":selected").attr("variant-image-card") == "false") {
            $(this).parents(".grid__item").find(".card__media img").attr("src", $(this).parents(".grid__item").find(".card__media .media").attr("variant-data-img"));
        } else {
            $(this).parents(".grid__item").find(".card__media img").attr("src", $(this).find(":selected").attr("variant-image-card"));
        }
    });
    $(window).scroll(function() {
        if ($(".shopify-section-header-sticky").hasClass("shopify-section-header-hidden")) {
            $(".faq-main-panel .faq-left-panel ul").addClass("sticky-faq-left");
        } else {
            $(".faq-main-panel .faq-left-panel ul").removeClass("sticky-faq-left");
        }
    });
    $(document).on("click", "#checkout-product_pag", function() {
        var product_va = $(this).parents(".product-form").find("input.product-variant-id").val();
        var qut_in = $(this).parents(".product__info-wrapper").find(".quant_variant .quantity__input").val();
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
                quantity: qut_in,
                id: product_va
            },
            dataType: "json",
            success: function(data) {
                window.location.href = "/checkout";
            }
        });
    });
});

$(".product-form__input .select__select").on("change", function() {
    var oopt_val = $(this).val();
    $(this).find("option").each(function() {
        var opr_un = $(this).text();
        if (opr_un.includes(oopt_val)) {
            if (opr_un.includes("Unavailable")) {
                $(".product_box_che a#checkout-product_pag").addClass("prod_sold_out");
            } else {
                $(".product_box_che a#checkout-product_pag").removeClass("prod_sold_out");
            }
        }
    });
});

$(document).ready(function() {
    $(document).on("change", ".product_deal .variant-data-card-product-hp select", function() {
        if ($(this).find(":selected").attr("variant-discount-card") == "false") {
            $(this).parents(".image_conte").find(".badge--sale").addClass("hidden");
        } else {
            $(this).parents(".image_conte").find(".badge--sale").removeClass("hidden");
            $(this).parents(".image_conte").find(".badge--sale span").html($(this).find(":selected").attr("variant-discount-card"));
        }
        $(this).parents(".image_conte").find(".product-compare-week h4").html($(this).find(":selected").attr("variant-price-card"));
        if ($(this).find(":selected").attr("variant-compare-price-card") == "false") {
            $(this).parents(".image_conte").find(".product-compare-week span").addClass("hidden");
        } else {
            $(this).parents(".image_conte").find(".product-compare-week span").removeClass("hidden");
            $(this).parents(".image_conte").find(".product-compare-week span").html($(this).find(":selected").attr("variant-compare-price-card"));
        }
        $(this).parents(".image_conte").find("product-form .form-variant-id").val($(this).find(":selected").attr("variant-id-card"));
        if ($(this).find(":selected").attr("variant-stock-card") == "true") {
            $(this).parents(".image_conte").find("button.quick-add__submit span").first().text("Add to Cart");
            $(this).parents(".image_conte").find("button.quick-add__submit").removeAttr("disabled", "disabled");
        } else {
            $(this).parents(".image_conte").find("button.quick-add__submit span").first().text("Sold Out");
            $(this).parents(".image_conte").find("button.quick-add__submit").attr("disabled", "disabled");
        }
        if ($(this).find(":selected").attr("variant-image-card") == "false") {
            $(this).parents(".image_conte").find(".img_left img").attr("src", $(this).parents(".image_conte").find(".img_left").attr("data-hp-featured"));
        } else {
            $(this).parents(".image_conte").find(".img_left img").attr("src", $(this).find(":selected").attr("variant-image-card"));
        }
    });
    $(".custom-category-filter li").addClass("hidden");
    var blen = $(".custom-category-filter li").length;
    var count = 10;
    $(".custom-category-filter li").each(function(index) {
        if (index < 10) {
            $(this).removeClass("hidden");
        }
    });
    $(document).on("click", ".view-moew-category", function() {
        count = count + 10;
        $(".custom-category-filter li").each(function(index) {
            if (index < count) {
                $(this).removeClass("hidden");
            } else {
                return false;
            }
        });
        if (blen <= count) {
            $(".view-moew-category").hide();
        }
    });
    $("ul.product-grid .variant-data-card-product select").change();
    $(document).on("click", ".image_conte quantity-input button", function() {
        var qty = parseInt($(this).parents("quantity-input").find("input").val());
        qty = isNaN(qty) ? 0 : qty;
        $(this).parents(".image_conte").find("product-form input#quantity").val(qty);
    });
    if ($(window).width() < 750) {
        $(document).on("click", ".faq-main-panel .main-faq-block", function() {
            var idscroll = $(this).attr("id");
            setTimeout(function() {
                $("html, body").animate({
                    scrollTop: $("#" + idscroll).offset().top - 167
                }, 200);
            }, 1e3);
        });
    }
});

$(window).on("load", function() {
    $("#preloader").fadeOut("slow");
});